import { render, staticRenderFns } from "./functionCenter.vue?vue&type=template&id=03884862&scoped=true"
import script from "./functionCenter.vue?vue&type=script&lang=js"
export * from "./functionCenter.vue?vue&type=script&lang=js"
import style0 from "./functionCenter.vue?vue&type=style&index=0&id=03884862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03884862",
  null
  
)

export default component.exports